import { Env } from '/@/Env';
import { CurrentEstateRouteConfig } from '/@/modules/core/app/helpers/CurrentEstateRouteConfig';

export const router = Env.isDevelopment()
  ? [
      CurrentEstateRouteConfig.factory({
        path: '/dev/steps/:key',
        name: 'dev-guidancesteps',
        component: () => import('/@/modules/dev/pages/GuidanceStepTestPage.vue'),
        meta: { authOnly: true }
      }).build(),
      CurrentEstateRouteConfig.factory({
        path: '/dev/stepviz',
        name: 'dev-stepviz',
        component: () => import('/@/modules/dev/pages/GuidanceStepVizPage.vue'),
        meta: { authOnly: true }
      }).build(),
      {
        path: '/dev/benchmark',
        name: 'dev-benchmark',
        component: () => import('/@/modules/dev/pages/BenchmarkPage.vue'),
        meta: { authOnly: false }
      }
    ]
  : [];
